import { FaMinus as MinusIcon } from 'react-icons/fa'

export default MinusIcon;
